document.addEventListener("click", function (e) {
    const trigger = e.target.closest(".ov25-showcase__card");
    if (!trigger) return;
    waitForContainerAndRender();
});

function waitForContainerAndRender() {
    const checkAndRender = () => {
        const container = document.getElementById("gallery-showcase");

        if (!container) return false;

        if (!container.querySelector(".captureSnapshot-ov25")) {
            if (!container.querySelector("#captureSnapshot")) {
                const btn = document.createElement("button");
                btn.id = "captureSnapshot";
                btn.innerText = "Capture your design";
                btn.classList.add("button", "captureSnapshot-ov25");

                container.parentNode.insertBefore(btn, container);
            }
        }

        return true;
    };

    // Try immediately first
    if (checkAndRender()) return;

    // Otherwise observe DOM until it appears
    const observer = new MutationObserver(() => {
        if (checkAndRender()) {
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

document.addEventListener("DOMContentLoaded", () => {
    //start capture API  
  let latestBlobUrl = null;

  function deepFindIframe() {
    const roots = [document];

    for (let i = 0; i < roots.length; i++) {
      const root = roots[i];

      const byId = root.querySelector?.('#ov25-configurator-iframe');
      if (byId) return byId;

      root.querySelectorAll?.('*').forEach(el => {
        if (el.shadowRoot) roots.push(el.shadowRoot);
      });
    }

    const iframes = roots.flatMap(root =>
      [...(root.querySelectorAll?.('iframe') || [])]
    );

    return iframes.find(f => /ov25|orbital|configurator/i.test(f.src || ''));
  }

  async function requestSnapshotBitmap() {
    const sleep = (ms) => new Promise(r => setTimeout(r, ms));

    let iframe;

    for (let i = 0; i < 50; i++) {
      iframe = deepFindIframe();
      if (iframe?.contentWindow) break;
      await sleep(100);
    }

    if (!iframe?.contentWindow) {
      throw new Error("Orbital iframe not found");
    }

    const requestId = `snapshot-${Date.now()}`;

    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => {
        window.removeEventListener("message", onMessage);
        reject(new Error("Snapshot timeout"));
      }, 15000);

      function onMessage(event) {
        const data = event.data;
        if (!data || data.requestId !== requestId) return;

        if (data.type === "TRANSITION_SNAPSHOT") {
          clearTimeout(timer);
          window.removeEventListener("message", onMessage);
          resolve(data.bitmap);
        }
      }

      window.addEventListener("message", onMessage);

      iframe.contentWindow.postMessage({
        type: "REQUEST_TRANSITION_SNAPSHOT",
        payload: JSON.stringify({ requestId })
      }, "*");
    });
  }

  async function downloadBitmap(bitmap) {
    // const product_page = document.querySelector(".product-page");
    // const product_title = product_page.querySelector(".product__title").textContent.trim();    

    const canvas = document.createElement("canvas");
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(bitmap, 0, 0);

    const blob = await new Promise(resolve =>
      canvas.toBlob(resolve, "image/png")
    );

    latestBlobUrl = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = latestBlobUrl;
    a.download = `DF-${Date.now()}.png`;
    a.click();

    URL.revokeObjectURL(latestBlobUrl);
  }

  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("#captureSnapshot");
    if (!btn) return;
        try {
        console.log("Requesting Orbital bitmap snapshot...");
        const bitmap = await requestSnapshotBitmap();
        console.log("Bitmap received:", bitmap);

        await downloadBitmap(bitmap);

        } catch (err) {
        console.error("Snapshot failed:", err);
        alert("Failed to capture product image. Please try again.");
        }
  });

});
